import Cookies from 'js-cookie';
import { useState, ViewTransition } from 'react';

import { getENV, type SitePreviewData, useSitePreviewData } from '@libs/common-next';

import { Configuration } from './configuration';
import { Entries } from './entries';
import css from './preview.module.scss';

export function Preview() {
    const sitePreviewData = useSitePreviewData();
    const [state, setState] = useState<SitePreviewData>(() => sitePreviewData ?? {});
    const [dirty, setDirty] = useState(false);

    if (!getENV('NEXT_PUBLIC_SITE_PREVIEW')) return null;

    const removePreviewParam = () => {
        const url = new URL(globalThis.location.href);
        url.searchParams.delete('_preview');
        globalThis.history.replaceState(null, '', url);
    };

    const handleChange = (key: keyof SitePreviewData, value: SitePreviewData[keyof SitePreviewData]) => {
        const newState = { ...state, [key]: value };
        setState(newState);
        Cookies.set('x-petm-preview', JSON.stringify(newState), {
            expires: 1 / 24, // 1 hour
        });
        removePreviewParam();
        setDirty(true);
    };

    const handleLeave = () => {
        Cookies.remove('x-petm-preview');
        removePreviewParam();
        globalThis.location.reload();
    };

    const handleRefresh = () => {
        removePreviewParam();
        globalThis.location.reload();
    };

    return (
        <ViewTransition name="container">
            <div className={css.wrapper}>
                <div className={css.section}>
                    <div className={css.scrollArea}>
                        <Configuration state={state} onChange={handleChange} />
                    </div>

                    <div className={css.footer}>
                        <button className={`${css.btn} ${css.buttonLeave}`} onClick={handleLeave}>
                            <span>⊘</span>
                            Leave Preview
                        </button>
                        <div className={css.footerActions}>
                            {dirty && <span className={css.refreshHint}>Refresh to see changes</span>}
                            <button className={`${css.btn} ${css.buttonRefresh}`} onClick={handleRefresh}>
                                <span>⊙</span>
                                Refresh
                            </button>
                        </div>
                    </div>
                </div>

                <Entries />
            </div>
        </ViewTransition>
    );
}
